import http from '@/core/http';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import {
  GetV1AccountInfoApiResItem,
  IAccountInfoParams,
  IAccountInfoLogs,
} from './index.d';

/**
 * 开发者帐号 — 列表
 * @see https://yapi.baibu.la/project/996/interface/api/72998
 *
 * @请求方法: GET
 * @请求地址: /web/v1/account-info
 * @更新时间: 2021-04-25 18:38:53
 */
export const getV1AccountInfoApi = () => {
  return http.get<GetV1AccountInfoApiResItem[]>({
    url: '/manage-app/web/v1/account-info',
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 开发者帐号 — 添加
 * @see https://yapi.baibu.la/project/996/interface/api/72994
 *
 * @请求方法: POST
 * @请求地址: /web/v1/account-info
 * @更新时间: 2021-04-2dd5 16:52:32
 */
export const AddAccountInfoApi = (params: IAccountInfoParams) => {
  return http.post({
    url: '/manage-app/web/v1/account-info',
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 开发者帐号 — 更新
 * @see https://yapi.baibu.la/project/996/interface/api/72996
 *
 * @请求方法: PUT
 * @请求地址: /web/v1/account-info
 * @更新时间: 2021-04-25 16:52:32
 */
export const putV1AccountInfoApi = (params: IAccountInfoParams) => {
  return http.put({
    url: '/manage-app/web/v1/account-info',
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
/**
 * 开发者帐号 — 停用
 * @see https://yapi.baibu.la/project/996/interface/api/73000
 *
 * @请求方法: PUT
 * @请求地址: /web/v1/account-info/updateEnable
 * @更新时间: 2021-04-25 16:52:32
 */
export const putV1AccountInfoUpdateEnableApi = (params: {
  id: string;
  remark?: string;
  isEnabled: string;
}) => {
  return http.put({
    url: '/manage-app/web/v1/account-info/updateEnable',
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 续费
export const reneAccountInfo = (id: string) => {
  return http.get({
    url: `/manage-app/web/v1/account-info/renew/${id}`,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 操作记录
export const accountInfoLogs = (id: string) => {
  return http.get<IAccountInfoLogs[]>({
    url: `/manage-app/web/v1/account-Log/${id}`,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 获取开发者账号列表
export const getAccountList = (params: {
  accountName: string;
}) => {
  return http.get<GetV1AccountInfoApiResItem[]>({
    url: '/manage-app/web/v1/account-info/account-list',
    params,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
